import { CatenaXReceivedRequestControllerApiFactory } from '@api-client/api'
import { QueryKey } from '@helpers/enums'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { useAsyncApi } from './useAsyncApi'

const useCatenaRequests = () => {
	const catenaXReceivedRequestApi = useAsyncApi(
		CatenaXReceivedRequestControllerApiFactory
	)

	return useQuery({
		queryKey: [QueryKey.ListCatenaRequests],
		queryFn: () =>
			catenaXReceivedRequestApi(api => api.listCatenaXReceivedRequests()).then(
				r => r.data
			),
	})
}

const useRejectCatenaRequests = () => {
	const queryClient = useQueryClient()
	const catenaXReceivedRequestApi = useAsyncApi(
		CatenaXReceivedRequestControllerApiFactory
	)

	const { mutateAsync: rejectAsync } = useMutation({
		mutationKey: [QueryKey.RejectCatenaRequest],
		mutationFn: ({ id, comment }: { id: string; comment: string }) =>
			catenaXReceivedRequestApi(api =>
				api.rejectCatenaXRequest(id, { comment })
			),
		onSuccess: () => {
			void queryClient.invalidateQueries({
				queryKey: [QueryKey.ListCatenaRequests],
			})
		},
	})

	return rejectAsync
}

const useAcceptCatenaRequests = () => {
	const queryClient = useQueryClient()
	const catenaXReceivedRequestApi = useAsyncApi(
		CatenaXReceivedRequestControllerApiFactory
	)

	const { mutateAsync: acceptAsync } = useMutation({
		mutationKey: [QueryKey.AcceptCatenaRequest],
		mutationFn: (id: string) =>
			catenaXReceivedRequestApi(api => api.approveCatenaXRequest(id)),
		onSuccess: () => {
			void queryClient.invalidateQueries({
				queryKey: [QueryKey.ListCatenaRequests],
			})
		},
	})

	return acceptAsync
}

export { useAcceptCatenaRequests, useCatenaRequests, useRejectCatenaRequests }
